<div [ngStyle]="{ 'display': 'flex', 'justify-content': 'flex-end' }">
    <a [routerLink]="['/dashboard/filesearch']" [state]="{ tagged: true }" class="btn btn-sm btn-link" title="View Tagged Items">
        View Tagged Items <i [style.margin-left.px]="4" class="fas fa-external-link-alt"></i>
    </a>
</div>

<app-file-explorer [loading]="loading"></app-file-explorer>